import React from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import cs from 'classnames';

type TOnlineOnlyBadgeProps = {
    className?: string;
};

export const OnlineOnlyBadge = ({className}: TOnlineOnlyBadgeProps) => {
    return (
        <div className={cs(style.label, className)}>
            <Typography variant={'label-12-r'}>Только онлайн</Typography>
        </div>
    );
};
